var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.element.playing ? 'animated ' + _vm.element.animatedName : '',
    _vm.element.loop ? 'infiniteKKKKK' : '',
    'element-wrapper',
    _vm.element._groupId ? _vm.element._groupId : ''
  ],style:({
    transform: 'rotate(' + _vm.element.transform + 'deg)',
    'z-index': _vm.element.zindex,
    opacity: _vm.element.opacity / 100,
    width: _vm.element.width + 'px',
    height: _vm.element.height + 'px',
    top: _vm.element.top + 'px',
    left: _vm.element.left + 'px',
    'animation-duration': _vm.element.duration + 's',
    '-webkit-animation-duration': _vm.element.duration + 's',
    'animation-delay': _vm.element.delay + 's',
    '-webkit-animation-delay': _vm.element.delay + 's',
    'display': (_vm.element.isHidden == null || !_vm.element.isHidden) ? 'block' : 'none'
  })},[(_vm.element.type !== 'scene')?_c('div',[_c(_vm.getCompName(_vm.element.type),{tag:"component",attrs:{"element":_vm.element}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }